import React, { useEffect, useState } from 'react';
import styles from './EditCardModal.module.css';
import { type CardsModel } from '../../../../../../../../utils/types';
import { ModalDefault } from '../../../../../../../../components/ModalDefault/ModalDefault';
import { SwitchButton } from '../SwitchButton/SwitchButton';
import { ControlledInput } from '../../../../../../../../components/ControlledInput/ControlledInput';
import DeleteCardModal from '../DeleteCardModal/DeleteCardModal';
import { transformFunction } from '../../../../AddCard/utils';
import { useFormContext } from 'react-hook-form';

interface TEditCardModalProps {
  card?: CardsModel;
  open: boolean;
  setOpen: (value: boolean) => void;
}
export const EditCardModal: React.FC<TEditCardModalProps> = ({ card, open, setOpen }) => {
  const [modalActive, setModalActive] = useState<boolean>(false);
  const { setValue, register } = useFormContext();

  useEffect(() => {
    if (card) {
      setValue('newDescription', card.description);
      setValue('newLimit', String(card.total_limit));
      setValue('newMinIncome', String(card.min_income));
      setValue('newMaxIncome', String(card.max_income));
      setValue('newInstantOrders', String(card.instant_active_orders));
      setValue('newDailyLimit', String(card.daily_total_limit || 0));
      setValue('newMonthlyLimit', String(card.monthly_total_limit || 0));
      setValue('newDailyLimitEnabled', !!card.daily_limit_enabled);
      setValue('newMonthlyLimitEnabled', !!card.monthly_limit_enabled);
    }
  }, [card, setValue]);

  return (
    <>
      <ModalDefault title={''} active={open} setActive={setOpen}>
        <div className={styles.wrapper}>
          <div className={styles.item}>
            <p className={styles.title}>ID: {card?.id}</p>
          </div>
          <div className={styles.item}>
            <p className={styles.title}>Активность</p>
            <SwitchButton active={card?.active || false} id={card?.id || 0} />
          </div>
          <div className={styles.item}>
            <p className={styles.title}>Описание</p>
            <ControlledInput
              placeholder={''}
              name={'newDescription'}
              type={'text'}
              title={''}
              defaultValue={card?.description}
            />
          </div>
          <div className={styles.item}>
            <p className={styles.title}>Номер карты:</p>
            <p className={styles.value}>{card?.account_number}</p>
          </div>
          <div className={styles.item}>
            <p className={styles.title}>ФИО:</p>
            <p className={styles.value}>{card?.fio}</p>
          </div>
          <div className={styles.item}>
            <p className={styles.title}>Банк:</p>
            <p className={styles.value}>{card?.bank.name}</p>
          </div>
          <div className={styles.item}>
            <p className={styles.title}>Общий лимит:</p>
            <ControlledInput
              defaultValue={card?.total_limit}
              placeholder={'Лимит карты'}
              name={'newLimit'}
              type={'text'}
              rules={{ required: true, maxLength: 13 }}
              transform={(text: string | undefined) => {
                if (text) {
                  return text
                    .replace(/[^0-9]/g, '')
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
                    .slice(0, 13);
                }
                return text;
              }}
            />
          </div>
          <div className={styles.item}>
            <p className={styles.title}>Минимальная сумма платежа:</p>
            <ControlledInput
              defaultValue={String(card?.min_income)}
              placeholder={'0'}
              name={'newMinIncome'}
              type={'text'}
              rules={{ required: true }}
              transform={transformFunction}
            />
          </div>
          <div className={styles.item}>
            <p className={styles.title}>Максимальная сумма платежа:</p>
            <ControlledInput
              defaultValue={String(card?.max_income)}
              placeholder={'0'}
              name={'newMaxIncome'}
              type={'text'}
              rules={{ required: true }}
              transform={transformFunction}
            />
          </div>
          <div className={styles.item}>
            <p className={styles.title}>Заявок одновременно не более:</p>
            <ControlledInput
              defaultValue={String(card?.instant_active_orders)}
              placeholder={'0'}
              name={'newInstantOrders'}
              type={'text'}
              rules={{ required: true }}
              transform={(text: string | undefined) => {
                if (text) {
                  return text.replace(/[^0-9]/g, '');
                }
                return text;
              }}
            />
          </div>
          <div className={styles.item}>
            <p className={styles.title}>Дневной лимит:</p>
            <label style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
              <input type='checkbox' {...register('newDailyLimitEnabled')} defaultChecked={!!card?.daily_limit_enabled} />
              Активен
            </label>
            <ControlledInput
              defaultValue={String(card?.daily_total_limit || 0)}
              placeholder={'0'}
              name={'newDailyLimit'}
              type={'text'}
              transform={transformFunction}
            />
          </div>
          <div className={styles.item}>
            <p className={styles.title}>Месячный лимит:</p>
            <label style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
              <input type='checkbox' {...register('newMonthlyLimitEnabled')} defaultChecked={!!card?.monthly_limit_enabled} />
              Активен
            </label>
            <ControlledInput
              defaultValue={String(card?.monthly_total_limit || 0)}
              placeholder={'0'}
              name={'newMonthlyLimit'}
              type={'text'}
              transform={transformFunction}
            />
          </div>
          <div className={styles.buttonContainer}>
            <button
              className={styles.delete}
              onClick={() => {
                setModalActive(true);
              }}
            >
              <img src={'/delete_white_icon.png'} alt={'delete icon'} /> Удалить
            </button>
            <button className={styles.save} type={'submit'}>
              <img src={'/save_white_icon.png'} alt={'save icon'} /> Сохранить
            </button>
          </div>
        </div>
      </ModalDefault>
      <DeleteCardModal
        id={card?.id || 0}
        setModalActive={setModalActive}
        modalActive={modalActive}
      />
    </>
  );
};
